import { Button, Icon, Text } from "@ttc3k/trekker";
import { Flask, Xmark } from "iconoir-react";
import { Collapsible } from "shared/components/molecules";
import { Flex } from "styled-system/jsx";
import { useTranslation } from "react-i18next";

type SandboxBannerProps = {
  organizationId: string;
  open: boolean;
  onClose: () => void;
};

export const CLOSE_SANDBOX_BANNER_KEY = "CLOSE_SANDBOX_BANNER";

/**
 * Get the localStorage key for a specific organization's sandbox banner
 */
export const getSandboxBannerKey = (organizationId: string) =>
  `${CLOSE_SANDBOX_BANNER_KEY}_${organizationId}`;

/**
 * Check if the sandbox banner has been dismissed for a specific organization
 */
export const isSandboxBannerDismissed = (organizationId: string): boolean => {
  return localStorage.getItem(getSandboxBannerKey(organizationId)) === "true";
};

export const SandboxBanner = ({
  organizationId,
  open,
  onClose,
}: SandboxBannerProps) => {
  const { t } = useTranslation("core");

  const handleClose = () => {
    // Save the closure of this sandbox banner to local storage so
    // the user doesn't see it again for this organization.
    localStorage.setItem(getSandboxBannerKey(organizationId), "true");
    onClose();
  };

  return (
    <Collapsible open={open}>
      <Flex
        w={"full"}
        h={"64px"}
        bg={"linear-gradient(90deg, #F97316 0%, #FB923C 100%)"}
        gap={"600"}
        justifyContent={"space-between"}
        alignItems={"center"}
        px={"300"}
      >
        <Flex gap={"150"} color={"white"}>
          <Icon Element={Flask} opacity={0.75} />
          <Text visual={"bodyMedium"}>{t("SANDBOX_BANNER.MESSAGE")}</Text>
        </Flex>

        <Button
          visual={"unstyled"}
          Icon={Xmark}
          color={"white"}
          css={{ "& > svg": { width: "icons.lg", height: "icons.lg" } }}
          _hover={{ color: "white/75" }}
          onClick={handleClose}
        />
      </Flex>
    </Collapsible>
  );
};
